import React from "react";
import styled from 'styled-components';
import SearchBrandAndProductList from './SearchBrandAndProductList'
import SearchDefaultBrandProductList from './SearchDefaultBrandProductList'
import Modal from 'react-modal';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import { getBrandStatInfoAction } from '../../modules/common/brandModule';
import LoadingOverlay from 'react-loading-overlay';
import { getBrandProductInfoAddAction, setSearchFilterDataAction, reSetBrandProductAddErrorAction } from '../../modules/search/searchModule';

Modal.setAppElement('#modal-root');

const BrandTableBloc = styled.div`
    display: ${props => props.display};
`;

const BrandTableListBloc = styled.div`
    //margin-top: -35px;
    //margin-bottom: 40px;
`;

const BrandAddViewBloc = styled.div`
    text-align: center;
`;

const BrandAddViewBtnBloc = styled.button`
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    display: ${props => props.display};//inline-block;
    border-radius: 4px;
`;

const BrandNoItemBloc = styled.div`
    position: relative;
    height: 180px;
`;

const BrandLoadingItemBloc = styled.div`
    position: relative;
    height: 360px;
`;

const BrandNoItemSpanBlock = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const StyleLoader = styled(LoadingOverlay)`
    padding:0px;
    margin : 0px;
    margin-top: 0px;
  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

const RETRY_COUNT = 3;
const BRAND_ITEM_OFFSET = 20;

const SearchBrandProductListContainer = () => {
    const dispatch = useDispatch();
    const [addView, setAddView] = useState(false);
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });
    const [addCallBrandList, setAddCallBrandList] = useState(false);
    const [reTryProduct, setReTryProduct] = useState(0);
    const [saveCount, setSaveCount] = useState(0);

    const { statInfo, errorStat, searchText, filterIndex, brandProductInfo, brandProductDefaultInfo, selFilterData,
        errorBrandProductAdd, loading, loading2, loading3, loading4 } = useSelector(
            ({ searchReducer, loadingReducer }) => ({
                statInfo: searchReducer.statInfo,
                errorStat: searchReducer.errorStat,
                searchText: searchReducer.searchText,
                loading: loadingReducer['search/GET_STAT'],
                loading2: loadingReducer['search/GET_BRAND_PRODUCT'],
                loading3: loadingReducer['search/GET_BRAND_PRODUCT_DEFAULT'],
                loading4: loadingReducer['search/REQ_TYPE_GET_BRNAD_PRODUCT_ADD'],
                filterIndex: searchReducer.filterIndex,
                brandProductInfo: searchReducer.brandProductInfo,
                brandProductDefaultInfo: searchReducer.brandProductDefaultInfo,
                errorBrandProduct: searchReducer.errorBrandProduct,
                errorBrandProductDefault: searchReducer.errorBrandProductDefault,
                selFilterData: searchReducer.selFilterData,
                errorBrandProductAdd: searchReducer.errorBrandProductAdd,

            })
        );

    const getBrandIdNumFromStatFilter = () => {
        let type = parseInt(selFilterData.type);
        let value = selFilterData.data;

        // console.log("save data = "+JSON.stringify(selFilterData));

        if (statInfo.totalnum === 0) {
            return 0;
        }

        //type : 0 한글  1: 영어  3: 전체
        if (type === 0) {
            let index = statInfo.filterBrandInfo.han.findIndex(x => x.key === value);
            // console.log("index = " + index);

            let bucket = statInfo.filterBrandInfo.han[index].BrandId.buckets;
            return bucket.length;

        }
        else if (type === 1) {
            let index = statInfo.filterBrandInfo.eng.findIndex(x => x.key === value);
            let bucket = statInfo.filterBrandInfo.eng[index].BrandId.buckets;
            return bucket.length;
        }
        else if (type === 3) {
            let bucket = statInfo.dataList;
            return bucket.length;
        }
    }

    const getBrandIdFromStatFilterForAdd = (offset) => {
        let type = parseInt(selFilterData.type);
        let value = selFilterData.data;
        //type : 0 한글  1: 영어  3: 전체
        if (type === 0) {
            let index = statInfo.filterBrandInfo.han.findIndex(x => x.key === value);
            let bucket = statInfo.filterBrandInfo.han[index].BrandId.buckets;
            let stringId = bucket[offset].key;
            for (var i = offset + 1; i < bucket.length && i < offset + BRAND_ITEM_OFFSET; i++) {
                stringId = stringId + "," + bucket[i].key;
            }

            return stringId;
        }
        else if (type === 1) {
            let index = statInfo.filterBrandInfo.eng.findIndex(x => x.key === value);
            let bucket = statInfo.filterBrandInfo.eng[index].BrandId.buckets;
            let stringId = bucket[offset].key;
            for (var i = offset + 1; i < bucket.length && i < offset + BRAND_ITEM_OFFSET; i++) {
                stringId = stringId + "," + bucket[i].key;
            }

            return stringId;
        }
        else if (type === 3) {
            let bucket = statInfo.dataList;
            let stringId = bucket[offset].key;
            for (var i = offset + 1; i < bucket.length && i < offset + BRAND_ITEM_OFFSET; i++) {
                stringId = stringId + "," + bucket[i].key;
            }
            return stringId;
        }
    }

    useEffect(() => {
        if (scrollPostion.heignt > 0 && scrollPostion.isClick) {
            window.scrollTo(0, scrollPostion.heignt);
        }
        if (brandProductInfo !== null && statInfo !== null) {

            if ((parseInt(selFilterData.offset) + BRAND_ITEM_OFFSET) < getBrandIdNumFromStatFilter()) {
                setAddView(true);
            }
            else {
                setAddView(false);
            }
            setAddCallBrandList(false);
        }
        setScrollPostion({ heignt: 0, isClick: false });

        return () => {
            //console.log( "BrBrandNoContainer end = ");
        };

    }, [brandProductInfo]);


    //더보기 에러난 경우 재요청
    useEffect(() => {
        if (errorBrandProductAdd !== null && reTryProduct < RETRY_COUNT) {
            if (searchText !== null && searchText.length > 0 && statInfo && statInfo.totalnum > 0) {
                // console.log('useEffect filterIndex = ' + filterIndex);
                let brandId = getBrandIdFromStatFilterForAdd(saveCount);
                dispatch(getBrandProductInfoAddAction(searchText, brandId, selFilterData.value, selFilterData.type, "0"));
            }
            setReTryProduct(reTryProduct + 1);
            dispatch(reSetBrandProductAddErrorAction());
        }
        else {
            setReTryProduct(0);
        }
    }, [errorBrandProductAdd])

    const onClickAddView = () => {
        let count = parseInt(selFilterData.offset) + BRAND_ITEM_OFFSET;
        if (count < getBrandIdNumFromStatFilter()) {
            //let offset = count.toString();
            let brandId = getBrandIdFromStatFilterForAdd(count);
            setSaveCount(count);
            dispatch(getBrandProductInfoAddAction(searchText, brandId, selFilterData.value, selFilterData.type, "0"));
            dispatch(setSearchFilterDataAction({ data: selFilterData.data, type: selFilterData.type, offset: count.toString() }));
        }

        setScrollPostion({ heignt: window.scrollY, isClick: true });
    }

    const getNoItemBlock = () => {
        // console.log("getNoItemBlock");
        return (
            <BrandNoItemBloc>
                <BrandNoItemSpanBlock>
                    검색된 브랜드가 없습니다.
                </BrandNoItemSpanBlock>
            </BrandNoItemBloc>
        );
    }

    const getLoagding = () => {

        if (loading || loading2 || loading3 || loading4) {
            return true;
        }

        return false;
    }
    const getList = () => {
        //검색어 없으면 디폴트 브랜드/상품 정보 보여주기
        if (searchText === null || (searchText && searchText.length < 1)) {
            if (brandProductDefaultInfo && brandProductDefaultInfo.dataList.length > 0) {
                return brandProductDefaultInfo.dataList.map((brInfo, index) => {
                    //console.log('brInfo._source.id = '+brInfo._source.id);
                    if (brInfo.totalnum > 0)
                        return <SearchDefaultBrandProductList key={brInfo.id.toString()} brInfo={brInfo} />
                })
            }
        }
        //검색어 있지만 상품 정보가 없는 경우, 디폴트 브랜드/상품 정보 보여주기
        else if (statInfo !== null && statInfo.totalnum === 0) {
            if (brandProductDefaultInfo && brandProductDefaultInfo.dataList.length > 0) {
                return brandProductDefaultInfo.dataList.map((brInfo, index) => {
                    //console.log('brInfo._source.id = '+brInfo._source.id);
                    if (brInfo.totalnum > 0)
                        return <SearchDefaultBrandProductList key={brInfo.id.toString()} brInfo={brInfo} />
                })
            }
        }
        else if (statInfo != null && statInfo.totalnum > 0) {
            if (brandProductInfo && brandProductInfo.totalnum > 0) {
                if (filterIndex === -1) {
                    return statInfo.dataList.map((bucket) => {
                        let index = brandProductInfo.dataList.findIndex(x => x._source.id === bucket.key);
                        if (index > -1) {
                            let brInfo = brandProductInfo.dataList[index];
                            //console.log("brInfo._source.id = "+brInfo._source.id);
                            if (brInfo.totalnum > 0)
                                return <SearchBrandAndProductList key={brInfo._source.id.toString()} brInfo={brInfo} />
                        }

                    })

                }
                else {
                    return brandProductInfo.dataList.map((brInfo, index) => {
                        //console.log('brInfo._source.id = '+brInfo._source.id);
                        if (brInfo.totalnum > 0)
                            return <SearchBrandAndProductList key={brInfo._source.id.toString()} brInfo={brInfo} />
                    })
                }
            }
        }
    }
    return (
        <BrandTableBloc>
            <StyleLoader
                active={getLoagding()}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                <BrandTableListBloc>
                    {
                        getList()
                    }
                </BrandTableListBloc>
                <BrandAddViewBloc>
                    <BrandAddViewBtnBloc display={addView ? 'inline-block' : "none"} onClick={onClickAddView}>
                        더보기
                    </BrandAddViewBtnBloc>
                </BrandAddViewBloc>
            </StyleLoader>
        </BrandTableBloc>
    );
};

export default SearchBrandProductListContainer;